import { TranslationModel } from "models/translation";

export const fiTranslations: TranslationModel = {
  yes: "Kyllä",
  no: "Ei",

  nav_logout: "Kirjaudu ulos",
  not_found_title: "Not found",

  shared_login: "Kirjaudu",

  privacy_policy: "Tietosuojaseloste",
  accessibility: "Saavutettavuusseloste",

  locale_fi: "Suomi",
  locale_en: "Englanti",
  locale_sv: "Ruotsi",

  show_in_locale_fi: "Suomeksi",
  show_in_locale_en: "Englanniksi",
  show_in_locale_sv: "Ruotsiksi",

  no_rows: "Ei tietoja",
  go_back: "Palaa takaisin",

  user_status: "Ilmoituksen tila",

  login_title: "Kirjautuminen",
  login_error: "Kirjautuminen epäonnistui",
  login_or: "Tai",
  login_with_ftn: "Kirjaudu verkkopankkitunnuksilla",
  login_button: "Kirjaudu",
  login_label_email: "Sähköpostiosoite",
  login_label_password: "Salasana",
  login_link_expired_title: "Linkki viallinen tai vanhentunut",
  login_link_expired_text:
    "Avaamasi linkki on viallinen tai vanhentunut. Ota yhteyttä luettelon ylläpitäjään saadaksesi uusi, toimiva linkki.",
  login_link_p1:
    "Voidaksesi päivittää tietojasi luettelossa tulee sinun tunnistautua.",
  login_link_p2:
    "Voit aloittaa painamalla alla olevaa painiketta, jonka jälkeen sinut ohjataan verkkopankkitunnuksilla tai mobiilivarmenteella tehtävään vahvaan tunnistautumiseen.",
  login_begin_auth: "Aloita tunnistautuminen",

  field_datatype_text: "Avoin kenttä",
  field_datatype_textarea: "Avoin kappale",
  field_datatype_email: "Sähköpostiosoite",
  field_datatype_date: "Päivämäärä",
  field_datatype_datetime: "Päivämäärä- ja kellonaika",
  field_datatype_dropdown: "Pudotusvalikko",
  field_datatype_check: "Valintaruutu",
  field_datatype_ssn: "Henkilötunnus",
  field_datatype_phone: "Puhelinnumero",
  field_datatype_radio: "Monivalinta",

  user_status_draft: "Luonnos",
  user_status_invited: "Ilmoitus pyydetty",
  user_status_progress: "Ilmoitus kesken",
  user_status_submitted: "Odottaa tarkastusta",
  user_status_approved: "Tarkastettu",

  email_filter_all: "Kaikki",
  email_filter_draft: "Ilmoitus kesken",

  email_template_type_invitation: "Kutsu ilmoittamaan",
  email_template_type_reminder: "Muistutus",
  email_template_type_update_request: "Pyyntö täydentää",
  email_template_type_approved: "Ilmoitus tarkastettu",
  email_template_type_rejected: "Ilmoitus vaatii korjauksia",
  email_template_type_custom: "",

  column_type_field: "Kenttä",
  column_type_name: "Nimi",
  column_type_modified: "Muokattu",
  column_type_status: "Tila",
  column_type_liabilities: "Luottamus- ja virkatehtävä",

  column_width_automatic: "Automaattinen",

  pdf_status: "Tila",
  pdf_date: "Päivämäärä",
  pdf_contains_secret_material: "Sisältää salaiseksi määriteltyjä tietoja.",

  validate_required: "Kenttä on pakollinen.",
  validate_email: "Virheellinen sähköpostiosoite.",
  validate_phone: "Virheellinen puhelinnumero.",
  validate_ssn: "Virheellinen henkilötunnus.",
  validate_password_min8: "Salasanan tulee olla vähintään 8 merkkiä pitkä.",
  validate_localestring_translation_missing: "Käännös puuttuu.",
  validate_password_same_as_old:
    "Salasana ei voi olla sama kuin vanha salasana.",
  validate_password_do_not_match: "Salasanat eivät ole samoja.",

  email_event_type_bounce: "Virheellinen osoite",
  email_event_type_click: "Viestiä klikattu",
  email_event_type_delivery: "Viesti lähetetty",
  email_event_type_open: "Viesti avattu",
  email_event_type_reject: "Viesti hylätty",
  email_event_type_complaint: "Merkitty roskapostiksi",
};
